module.exports = __webpack_public_path__ + "img/SameDayService.b90989e5.svg";